import { FC } from 'react'
import { prependAssetHost } from 'src/common/utils'

type NavAvatarProps = {
    imageUrl: string
}

export const NavAvatar: FC<NavAvatarProps> = ({ imageUrl }) => {
    return (
        <div className="bg-nav-avatar-pattern flex items-center relative max-w-[40px] max-h-[40px] sm:max-w-[58px] sm:max-h-[58px] rounded-full border-solid border-3 border-transparent z-0 my-1 mr-[5px]">
            <img
                src={imageUrl ? prependAssetHost(imageUrl) : '/profile-placeholder.png'}
                width="58px"
                height="58px"
                alt="Avatar image"
                className="w-full h-full z-10 rounded-full bg-gray-500"
            />
        </div>
    )
}
